import LeafletMap from "./map/LeafletMap";
import MapboxMap from "./map/MapboxMap";
import EditButton from "./subscription/EditButton";
import DeleteButton from "./subscription/DeleteButton";
import AddNewButton from "./subscription/AddNewButton";
import UnsubscribeInput from "./unsubscribe/UnsubscribeInput";
import UnsubscribeCheckbox from "./unsubscribe/UnsubscribeCheckbox";
/**
 * Enable [MAP]
 */
document.addEventListener('DOMContentLoaded', function () {
    if (!document.MapData) {
        console.debug("[AGILIS] Map Data missing! Not enabling...");
        return;
    }
    var mapData = document.MapData;
    var lineData = document.LineData;
    lineData = lineData ? lineData : [];
    var leafletMap = document.getElementById('map-leaflet');
    var mapboxMap = document.getElementById('map-mapbox');
    if (leafletMap)
        new LeafletMap(mapData, lineData, leafletMap);
    if (mapboxMap)
        new MapboxMap(mapData, lineData, mapboxMap);
});
/**
 * Enable [SUBSCRIPTION]
 */
document.addEventListener('DOMContentLoaded', function () {
    if (!document.SubscriptionData) {
        console.debug("[AGILIS] Subscription Data missing! Not enabling...");
        return;
    }
    var data = document.SubscriptionData;
    document.querySelectorAll('button.subscription-entry-edit').forEach(function (it) { return new EditButton(it); });
    document.querySelectorAll('button.subscription-entry-delete').forEach(function (it) { return new DeleteButton(it, data.misc.confirmDelete); });
    new AddNewButton(document.querySelector('#subscriptions-email'), data.email, data.misc.confirmDelete);
    new AddNewButton(document.querySelector('#subscriptions-sms'), data.sms, data.misc.confirmDelete);
});
/**
 * Enable [UNSUBSCRIBE]
 */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.form-unsubscribe').forEach(function (it) {
        var linesInputElem = it.querySelector('input[name="lines"]');
        if (!linesInputElem)
            return;
        var linesInput = new UnsubscribeInput(linesInputElem);
        it.querySelectorAll('.checkbox-container input[type="checkbox"]').forEach(function (cb) {
            new UnsubscribeCheckbox(cb, linesInput);
        });
    });
});
